import React from 'react';
import cn from 'classnames';

import { createFormField } from 'Shared/utils/createFormField';

import { roleOptions } from '../../../../constants';
import './FormChooseRole.scss';

type Props = {
  value: string;
  onChange: Function;
};

function ChooseRole({ value: role, onChange }: Props) {
  return (
    <div className="form-choose-role d-flex mt-3">
      {roleOptions.map(({ label, value }) => (
        <div
          key={value}
          className={cn('form-choose-role-circle d-flex mr-3 cursor-pointer', {
            'form-choose-role-circle--selected': role === value,
          })}
          onClick={() => onChange(value)}
        >
          <div className="m-auto text-center">{label}</div>
        </div>
      ))}
    </div>
  );
}

export default createFormField(ChooseRole);
